import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IFaceImage } from '@bca-user-data/models/face-image';
import { IMetric } from '@bca-user-data/models/metric';

@Component({
  selector: 'bca-result-upload',
  templateUrl: 'result-upload.component.html',
  styleUrls: ['result-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResultUploadComponent {
  @Input()
  image: IFaceImage;
  @Input()
  metrics: IMetric[];

  @Output()
  choose = new EventEmitter<void>();
  @Output()
  save = new EventEmitter<void>();
  @Output()
  checked = new EventEmitter<boolean>();
}
